import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-bottom-sheet-wrapper',
  templateUrl: './bottom-sheet-wrapper.component.html',
  styleUrls: ['./bottom-sheet-wrapper.component.scss'],
})
export class BottomSheetWrapperComponent {
  @Input() title: string = 'Bottom Sheet';
  @Input() subtitle: string | null = null;

  @Output() close = new EventEmitter<void>();

  emitClose(): void {
    this.close.emit();
  }
}
